import { Hero } from './hero.component';

export default Hero;
